import { Button, Typography } from 'design-library';

import './ErrorsPage.scss';

export const ErrorsPage = ({ statusCode = 404 }: { statusCode?: number }) => {
  return (
    <div
      className="errorsPage"
      style={{
        backgroundImage: `url(${
          process.env.PUBLIC_URL + '/images/error-page-background.png'
        })`,
      }}
    >
      <Typography variant="h1">Error</Typography>
      <Typography variant="subtitle1">{`${statusCode.toString()}`}</Typography>
      <Typography variant="subtitle2">Oops! Seems like you are lost</Typography>
      <Typography variant="subtitle2">Don’t panic, just</Typography>

      <div className="errorsPage-btn">
        <Button onClick={() => history.back()}>Go Back</Button>
      </div>
    </div>
  );
};
